import * as Yup from "yup";
import { TFunction } from "i18next";

export const stringSchema = (fieldName: string, t: TFunction, errorText: string = "pleaseEnter") => {
  return Yup.string()
    .required(t(errorText, { changeablePart: t(fieldName) }))
    .label(t(fieldName));
};

export const booleanSchema = (fieldName: string, t: TFunction) => {
  return Yup.boolean().label(t(fieldName));
};

export const numberSchema = (fieldName: string, t: TFunction, errorText: string = "pleaseEnter") => {
  return Yup.number()
    .required(t(errorText, { changeablePart: t(fieldName) }))
    .label(t(fieldName));
};
export const numberOptionalSchema = (fieldName: string, t: TFunction, errorText: string = "pleaseEnter") => {
  return Yup.number().label(t(fieldName));
};
export const arrayOfStrSchema = (fieldName: string, t: TFunction, errorText: string = "pleaseEnter") => {
  return (
    Yup.array()
      // .of(
      //   Yup.object().shape({
      //     value: Yup.string()
      //       .trim()
      //       .required(t("pleaseEnter", { changeablePart: t(fieldName) })),
      //   })
      // )
      .label(t(fieldName))
      .required(t(errorText, { changeablePart: t(fieldName) }))
  );
};

export const titleObjectSchema = (fieldName: string, t: TFunction) => {
  return Yup.object().shape({
    title: Yup.array()
      .of(
        Yup.object().shape({
          language: Yup.object()
            .nullable()
            .shape({ value: Yup.string(), label: Yup.string() })
            .required(t("isRequire", { changeablePart: t("language") })),
          value: Yup.string()
            .nullable()
            .required(t("isRequire", { changeablePart: t("value") })),
        })
      )
      .min(1, t("atLeastOne"))
      .required(t("isRequire", { changeablePart: t(fieldName) })),
  });
};
export const residentsTitleObjectSchema = (fieldName: string, t: TFunction) => {
  return Yup.object().shape({
    residentsTitle: Yup.array().of(
      Yup.object().shape({
        language: Yup.object()
          .nullable()
          .shape({ value: Yup.string(), label: Yup.string() })
          .required(t("isRequire", { changeablePart: t("language") })),
        value: Yup.string()
          .nullable()
          .required(t("isRequire", { changeablePart: t("value") })),
      })
    ),
    // .min(1, t("atLeastOne")),
    // .required(t("isRequire", { changeablePart: t(fieldName) })),
  });
};
export const citizensTitleObjectSchema = (fieldName: string, t: TFunction) => {
  return Yup.object().shape({
    citizensTitle: Yup.array().of(
      Yup.object().shape({
        language: Yup.object()
          .nullable()
          .shape({ value: Yup.string(), label: Yup.string() })
          .required(t("isRequire", { changeablePart: t("language") })),
        value: Yup.string()
          .nullable()
          .required(t("isRequire", { changeablePart: t("value") })),
      })
    ),
    // .min(1, t("atLeastOne")),
    // .required(t("isRequire", { changeablePart: t(fieldName) })),
  });
};
export const nameObjectSchema = (fieldName: string, t: TFunction) => {
  return Yup.array()
    .of(
      Yup.object().shape({
        language: Yup.object()
          .nullable()
          .shape({ value: Yup.string(), label: Yup.string() })
          .required(t("isRequire", { changeablePart: t("language") })),
        value: Yup.string()
          .nullable()
          .required(t("isRequire", { changeablePart: t("value") })),
      })
    )
    .min(1, t("atLeastOne"))
    .required(t("isRequire", { changeablePart: t(fieldName) }));
};
export const fieldWithTranslationSchema = (fieldName: string, t: TFunction) => {
  return Yup.array()
    .of(
      Yup.object().shape({
        language: Yup.object()
          .nullable()
          .shape({ value: Yup.string(), label: Yup.string() })
          .required(t("isRequire", { changeablePart: t("language") })),
        value: Yup.string()
          .nullable()
          .required(t("isRequire", { changeablePart: t("value") })),
      })
    )
    .min(1, t("atLeastOne"))
    .required(t("isRequire", { changeablePart: t(fieldName) }));
};

export const faqDetailsSchema = (t: TFunction) => {
  return Yup.array()
    .of(
      Yup.object().shape({
        title: fieldWithTranslationSchema("title", t),
        description: fieldWithTranslationSchema("description", t),
      })
    )
    .min(1, t("atLeastOneDetailRequired"))
    .required(t("isRequire", { changeablePart: t("details") }));
};

export const fieldWithTranslationSchemaOptional = (fieldName: string, t: TFunction) => {
  return Yup.array().of(
    Yup.object().shape({
      language: Yup.object()
        .nullable()
        .shape({ value: Yup.string(), label: Yup.string() })
        .required(t("isRequire", { changeablePart: t("language") })),
      value: Yup.string()
        .nullable()
        .required(t("isRequire", { changeablePart: t("value") })),
    })
  );
};
export const descriptionObjectSchema = (fieldName: string, t: TFunction) => {
  return Yup.object().shape({
    description: Yup.array()
      .of(
        Yup.object().shape({
          language: Yup.object()
            .nullable()
            .shape({ value: Yup.string(), label: Yup.string() })
            .required(t("isRequire", { changeablePart: t("language") })),
          value: Yup.string()
            .nullable()
            .required(t("isRequire", { changeablePart: t("description") })),
        })
      )
      .min(1, t("atLeastOne"))
      .required(t("isRequire", { changeablePart: t(fieldName) })),
  });
};
export const shortDescObjectSchema = (fieldName: string, t: TFunction) => {
  return Yup.object().shape({
    shortDescription: Yup.array()
      .of(
        Yup.object().shape({
          language: Yup.object()
            .nullable()
            .shape({ value: Yup.string(), label: Yup.string() })
            .required(t("isRequire", { changeablePart: t("language") })),
          value: Yup.string()
            .nullable()
            .required(t("isRequire", { changeablePart: t("value") })),
        })
      )
      .min(1, t("atLeastOne"))
      .required(t("isRequire", { changeablePart: t(fieldName) })),
  });
};

const mixedImageSchema = () => {
  return Yup.mixed()
    .nullable("icon is required")
    .test("is-valid-image", "Invalid image format", (value) => typeof value === "string" || (typeof value === "object" && value !== null && "path" in value));
};

export const stepsWithDescriptionsSchema = (t: TFunction) => {
  return Yup.array()
    .of(
      Yup.object()
        .shape({
          icon: mixedImageSchema(),
          shortDescription: shortDescObjectSchema("shortDescription", t),
        })
        .nullable()
    )
    .min(1, t("atLeastOneStep"))
    .required(t("isRequire", { changeablePart: t("steps") }));
};

export const detailsWithDescriptionsSchema = (t: TFunction) => {
  return Yup.array()
    .of(
      Yup.object()
        .shape({
          icon: mixedImageSchema(),
          description: descriptionObjectSchema("description", t),
        })
        .nullable()
    )
    .min(1, t("atLeastOneStep"))
    .required(t("isRequire", { changeablePart: t("details") }));
};
export const featuresWithDescriptionsTitlesSchema = (t: TFunction) => {
  return Yup.array()
    .of(
      Yup.object()
        .shape({
          icon: mixedImageSchema(),
          description: descriptionObjectSchema("description", t),
          title: titleObjectSchema("title", t),
        })
        .nullable()
    )
    .min(1, t("atLeastOneItem"))
    .required(t("isRequire", { changeablePart: t("features") }));
};
export const drivingTypeWithDescriptionsTitlesSchema = (t: TFunction) => {
  return Yup.array()
    .of(
      Yup.object()
        .shape({
          slug: stringSchema("slug", t),
          title: titleObjectSchema("title", t),
        })
        .nullable()
    )
    .min(1, t("atLeastOneItem"))
    .required(t("isRequire", { changeablePart: t("drivingType") }));
};
export const branchesWithDescriptionsTitlesSchema = (t: TFunction) => {
  return Yup.array()
    .of(
      Yup.object()
        .shape({
          slug: stringSchema("slug", t),
          description: descriptionObjectSchema("description", t),
          title: titleObjectSchema("title", t),
        })
        .nullable()
    )
    .min(1, t("atLeastOneItem"))
    .required(t("isRequire", { changeablePart: t("branches") }));
};
export const contentSchema = (t: TFunction) => {
  return Yup.array()
    .of(
      Yup.object()
        .shape({
          title: titleObjectSchema("title", t),
          details: detailsWithDescriptionsSchema(t),
        })
        .nullable()
    )
    .min(1, t("atLeastOneStep"))
    .required(t("isRequire", { changeablePart: t("details") }));
};

export const descriptionItemsSchema = (t: TFunction) => {
  return Yup.array()
    .of(
      Yup.object()
        .shape({
          title: titleObjectSchema("title", t),
          description: descriptionObjectSchema("description", t),
        })
        .nullable()
    )
    .min(1, t("atLeastOneDescItem"))
    .required(t("isRequire", { changeablePart: t("descriptionItems") }));
};
export const notesSchema = (t: TFunction) => {
  return Yup.array()
    .of(
      Yup.object()
        .shape({
          title: titleObjectSchema("title", t),
          description: descriptionObjectSchema("description", t),
        })
        .nullable()
    )
    .min(1, t("atLeastOneDescItem"))
    .required(t("isRequire", { changeablePart: t("notes") }));
};
export const titleDescriptionSchema = (fieldname: any, t: TFunction) => {
  return Yup.array().of(
    Yup.object()
      .shape({
        title: titleObjectSchema("title", t),
        description: descriptionObjectSchema("description", t),
      })
      .nullable()
  );
  // .min(1, t(`atLeastOne${fieldname}`))
  // .required(t("isRequire", { changeablePart: t(fieldname) }));
};

export const multiDescriptionSchema = (fieldName: string, t: TFunction) => {
  return Yup.object().shape({
    description: Yup.array()
      .of(
        Yup.object().shape({
          language: Yup.object()
            // .nullable()
            .shape({
              value: Yup.string().nullable(),
              label: Yup.string().nullable(),
            })
            .required(t("isRequire", { changeablePart: t("language") })),
          values: Yup.array()
            .of(
              Yup.object().shape({
                value: Yup.string()
                  // .nullable()
                  .required(t("isRequire", { changeablePart: t("descriptionValue") })),
              })
            )
            .min(1, t("atLeastOne"))
            .required(t("isRequire", { changeablePart: t("values") })),
        })
      )
      .min(1, t("atLeastOne"))
      .required(t("isRequire", { changeablePart: t(fieldName) })),
  });
};
export const multiDrivingTypeSchema = (fieldName: string, t: TFunction) => {
  return Yup.object().shape({
    drivingTypes: Yup.array()
      .of(
        Yup.object().shape({
          language: Yup.object()
            // .nullable()
            .shape({
              value: Yup.string().nullable(),
              label: Yup.string().nullable(),
            })
            .required(t("isRequire", { changeablePart: t("language") })),
          values: Yup.array()
            .of(
              Yup.object().shape({
                value: Yup.string()
                  // .nullable()
                  .required(t("isRequire", { changeablePart: t("drivingTypeValue") })),
              })
            )
            .min(1, t("atLeastOne"))
            .required(t("isRequire", { changeablePart: t("values") })),
        })
      )
      .min(1, t("atLeastOne"))
      .required(t("isRequire", { changeablePart: t(fieldName) })),
  });
};

export const multiSelectionSchema = (fieldName: string, t: TFunction) => {
  return Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required(t("isRequire", { changeablePart: t("value") })),
        label: Yup.string().required(t("isRequire", { changeablePart: t("label") })),
      })
    )
    .min(1, t("atLeasOneSelection"))
    .required(t("isRequire", { changeablePart: t(fieldName) }))
    .label(t(fieldName));
};
export const multiSelectionOptionalSchema = (fieldName: string, t: TFunction) => {
  return Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required(t("isRequire", { changeablePart: t("value") })),
        label: Yup.string().required(t("isRequire", { changeablePart: t("label") })),
      })
    )
    .label(t(fieldName));
};

export const passwordSchema = (fieldName: string, t: TFunction) => {
  return Yup.string()
    .min(6, t("minCharacters"))
    .required(t("pleaseEnter", { changeablePart: t(fieldName) }))
    .label(t(fieldName));
};

export const confirmPasswordSchema = (fieldName: string, t: TFunction, passwordFieldName: string) => {
  return Yup.string()
    .oneOf([Yup.ref(passwordFieldName)], t("passwordMustMatch"))
    .label(fieldName);
};

export const objectSchema = (fieldName: string, t: TFunction) => {
  return Yup.object().required(t("pleaseSelect", { changeablePart: t(fieldName) }));
};

export const translationTitle = (fieldName: string, t: TFunction) => {
  return Yup.array().of(
    Yup.object()
      .shape({
        language: Yup.object().required(t("pleaseSelect", { changeablePart: t("language") })),
        title: Yup.string().required(t("pleaseEnter", { changeablePart: t("title") })),
      })
      .required()
  );
};
export const translationName = (fieldName: string, t: TFunction) => {
  return Yup.array().of(
    Yup.object()
      .shape({
        language: Yup.object().required(t("pleaseSelect", { changeablePart: t("language") })),
        name: Yup.string().required(t("pleaseEnter", { changeablePart: t("name") })),
      })
      .required()
  );
};
export const translationDesc = (fieldName: string, t: TFunction) => {
  return Yup.array().of(
    Yup.object()
      .shape({
        language: Yup.object().required(t("pleaseSelect", { changeablePart: t("language") })),
        description: Yup.string().required(t("pleaseEnter", { changeablePart: t("description") })),
      })
      .required()
  );
};

export const descriptionValidation = (t: TFunction) => {
  return Yup.array().of(
    Yup.object()
      .shape({
        title: Yup.string().required(t("pleaseEnter", { changeablePart: t("title") })),
        details: Yup.array()
          .of(
            Yup.object().shape({
              text: Yup.string().required(t("pleaseEnter", { changeablePart: t("text") })),
              hasIcon: Yup.boolean(), // No need to validate `hasIcon` unless required
            })
          )
          .min(1, t("pleaseEnterAtLeastOneDetail")) // Require at least one detail
          .required(),
      })
      .required()
  );
};

export const detailsValidation = (t: TFunction) => {
  return Yup.array().of(
    Yup.object()
      .shape({
        title: Yup.string().required(t("pleaseEnter", { changeablePart: t("title") })),
        description: Yup.string().required(t("pleaseEnter", { changeablePart: t("description") })),
      })
      .required()
  );
};

export const imageSchema = (fieldName: string, t: TFunction) => {
  return Yup.lazy((value) => {
    if (value === undefined || value === null) {
      return Yup.mixed()
        .required(t("pleaseSelect", { changeablePart: t(fieldName) }))
        .label(fieldName);
    }
    switch (typeof value) {
      case "object":
        return Yup.object()
          .required(t("pleaseSelect", { changeablePart: t(fieldName) }))
          .label(fieldName); // schema for object
      case "string":
        return Yup.string()
          .required(t("pleaseSelect", { changeablePart: t(fieldName) }))
          .label(fieldName); // schema for string
      default:
        return Yup.mixed();
    }
  });
};

export const imageMultiSchema = (fieldName: string, t: TFunction) => {
  return Yup.lazy((value) => {
    if (value === undefined || value === null || (Array.isArray(value) && value.length === 0)) {
      return Yup.array()
        .of(Yup.mixed().required(t("pleaseSelect", { changeablePart: t(fieldName) })))
        .required(t("pleaseSelect", { changeablePart: t(fieldName) }))
        .label(fieldName);
    }
    if (Array.isArray(value)) {
      return Yup.array()
        .of(
          Yup.lazy((item) => {
            if (typeof item === "object") {
              return Yup.object()
                .required(t("pleaseSelect", { changeablePart: t(fieldName) }))
                .label(fieldName); // schema for object
            } else if (typeof item === "string") {
              return Yup.string()
                .required(t("pleaseSelect", { changeablePart: t(fieldName) }))
                .label(fieldName); // schema for string
            } else {
              return Yup.mixed();
            }
          })
        )
        .required(t("pleaseSelect", { changeablePart: t(fieldName) }))
        .label(fieldName);
    }
    return Yup.mixed();
  });
};
